module.exports = __webpack_public_path__ + "static/img/wanli.450a9d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/wanli.png
// module id = KIe2
// module chunks = 1